import ProtectedPublicRoute from "@/components/template/ProtectedPublicRoute";
import PublicNotFoundPage from "@/pages/public/NotFound";
import SignupV2Page from "@/src/pages/public/SignupV2";
import SignupV2MemberSignup from "@/src/pages/public/SignupV2/MemberSignup";
import SignupV2MemberResult from "@/src/pages/public/SignupV2/MemberSignup/MemberSignupResult";
import AccountPendingApproval from "@/src/pages/public/AccountPendingApproval";
import SignupV2Workspace from "@/src/pages/public/SignupV2/Workspace";
import SignupV2WorkspaceSuccess from "@/src/pages/public/SignupV2/WorkspaceSuccess";
import TermsPage from "@/pages/public/Terms";
import FindPasswordPage from "@/src/pages/public/FindPassword";
import LoginPage from "@/src/pages/public/Login";
import MainPage from "@/src/pages/public/MainPage";
import ContactUsPage from "@/src/pages/public/ContactUs";
import ContactUsSuccessPage from "@/src/pages/public/ContactUs/ContactUsSuccess";
import { RouteObject } from "react-router-dom";
import PUBLIC_PATH from "./path";

const publicRoutes: RouteObject[] = [
  {
    path: PUBLIC_PATH.ROOT,
    element: <ProtectedPublicRoute />,
    children: [
      {
        index: true, // Root path (/) shows MainPage
        element: <MainPage />,
      },
      {
        path: PUBLIC_PATH.LOGIN,
        element: <LoginPage />,
      },
      {
        path: PUBLIC_PATH.SIGNUP,
        element: <SignupV2Page />,
      },
      {
        path: PUBLIC_PATH.SIGNUP_MEMBER,
        element: <SignupV2MemberSignup />,
      },
      {
        path: PUBLIC_PATH.SIGNUP_MEMBER_RESULT,
        element: <SignupV2MemberResult />,
      },
      {
        path: PUBLIC_PATH.SIGNUP_PENDING_APPROVAL,
        element: <AccountPendingApproval />,
      },
      {
        path: PUBLIC_PATH.SIGNUP_WORKSPACE,
        element: <SignupV2Workspace />,
      },
      {
        path: PUBLIC_PATH.SIGNUP_WORKSPACE_SUCCESS,
        element: <SignupV2WorkspaceSuccess />,
      },
      {
        path: PUBLIC_PATH.FIND_PASSWORD,
        element: <FindPasswordPage />,
      },
    ],
  },
  {
    path: PUBLIC_PATH.CONTACT_US,
    element: <ContactUsPage />,
  },
  {
    path: PUBLIC_PATH.CONTACT_US_SUCCESS,
    element: <ContactUsSuccessPage />,
  },
  {
    path: PUBLIC_PATH.TERMS,
    element: <TermsPage />,
  },
  {
    path: PUBLIC_PATH.NOT_FOUND,
    element: <PublicNotFoundPage />,
  },
];

export default publicRoutes;
